import {
  SET_HOLDER_DETAILS,
  GET_HOLDER_CREDENTIALS_BEGIN,
  GET_HOLDER_CREDENTIALS_SUCCESS,
  GET_HOLDER_CREDENTIALS_FAILURE,
} from "./holders.constant";

const initState = {
  holderDetails: {},
  credentialsList: {
    loading: false,
    response: {},
    error: "",
  },
};

export const holderReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case SET_HOLDER_DETAILS:
      return { ...state, holderDetails: payload };
    case GET_HOLDER_CREDENTIALS_BEGIN:
      return {
        ...state,
        credentialsList: {
          loading: true,
        },
      };
    case GET_HOLDER_CREDENTIALS_SUCCESS:
      return {
        ...state,
        credentialsList: {
          loading: false,
          response: payload,
        },
      };
    case GET_HOLDER_CREDENTIALS_FAILURE:
      return {
        ...state,
        credentialsList: {
          loading: false,
          error: payload,
        },
      };
    default:
      return state;
  }
};
